import React from "react";
import { Breadcrumbs, Link, Typography, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import HomeIcon from "@mui/icons-material/Home";
import EventIcon from "@mui/icons-material/Event"; // <-- Import EventIcon

const segmentMap = {
  dashboard: {
    label: "Dashboard",
    icon: <HomeIcon fontSize="small" sx={{ mr: 0.5 }} />,
  },
  events: {
    label: "Events",
    icon: <EventIcon fontSize="small" sx={{ mr: 0.5 }} />, // <-- Use EventIcon
  },
};

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const formatSegment = (seg) => {
  if (segmentMap[seg]) {
    const { icon, label } = segmentMap[seg];
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {icon}
        <span>{label}</span>
      </Box>
    );
  }
  return capitalize(seg.replace(/-/g, " "));
};

export default function BreadcrumbsNav() {
  const location = useLocation();
  const navigate = useNavigate();

  // Remove leading slash, split, and filter out empty/dashboard
  const segments = location.pathname
    .split("/")
    .filter((seg) => seg && seg !== "dashboard");

  const paths = segments.map((seg, i) => ({
    segment: seg,
    href: "/" + segments.slice(0, i + 1).join("/"),
  }));

  return (
    <Box sx={{ mb: 3 }}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          color="inherit"
          href="/dashboard"
          onClick={(e) => {
            e.preventDefault();
            navigate("/dashboard");
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <HomeIcon fontSize="small" sx={{ mr: 0.5 }} />
            Dashboard
          </Box>
        </Link>

        {paths.map((p, i) => {
          const segment = formatSegment(p.segment);
          const isLast = i === paths.length - 1;

          return isLast ? (
            <Box
              key={i}
              sx={{
                display: "flex",
                alignItems: "center",
                color: "text.primary",
                fontWeight: "bold",
              }}
            >
              {segment}
            </Box>
          ) : (
            <Link
              key={i}
              underline="hover"
              color="inherit"
              href={p.href}
              onClick={(e) => {
                e.preventDefault();
                navigate(p.href);
              }}
              sx={{ display: "flex", alignItems: "center" }}
            >
              {segment}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
}
